<template>
  <div v-if="navigation.length > 0" >
    <!--<Sidebar :itemsNavigation="navigation" :sidebarOpen="sidebarOpen" />-->
    <NavSideBar :itemsNavigation="navigation" :sidebarOpen="sidebarOpen" />

    <div class="lg:pl-72">
        <Navbar>
          <template #content >

              <button type="button" class="-m-2.5 p-2.5 text-gray-700 lg:hidden" @click="sidebarOpen = ! sidebarOpen; console.log(sidebarOpen)">
                <span class="sr-only">Open sidebar</span>
                <Bars3Icon class="h-6 w-6" aria-hidden="true" />
              </button>

              <!-- Separator -->
              <div class="h-6 w-px bg-gray-900/10 lg:hidden" aria-hidden="true" />

              <div class="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
                <div class="flex items-start" style="margin-top: 5px;">
                  <img v-if="configData.brazao" class="py-2" :src="apiBase+'/configuracao/'+configData.brazao.replace('public/','')" style="height: 50px; " />
                  <p class="text-left mt-4 ml-2 uppercase"> Prefeitura Municipal de {{ configData.nome_municipio }} </p>
                </div>

                <form class="relative flex flex-1" action="#" method="GET">
                  <SizedBox />

                  <!-- <label for="search-field" class="sr-only">Search</label>
                  <MagnifyingGlassIcon class="pointer-events-none absolute inset-y-0 left-0 h-full w-5 text-gray-400" aria-hidden="true" />
                  <input id="search-field" class="block h-full w-full border-0 py-0 pl-8 pr-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm" placeholder="Search..." type="search" name="search" /> -->
                </form>

                <div class="flex items-center gap-x-4 lg:gap-x-6"  >
                  <Select
                    v-if="unidades.length > 1"
                    id="unidade"
                    name="unidade"
                    :options="unidades"
                    fieldLabel="nome"
                    fieldValue="id"
                    :value="unidade_logada"
                    :onChange="trocaUnidadeLogada"
                    style="margin-top: -10px;"
                  />

                  <!-- Separator -->
                  <div class="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10" aria-hidden="true" />

                  <ProfileDropdown :welcomeMessage="message" :userNavigation="userNavigation" />
                </div>
              </div>
          </template>
        </Navbar>

      <main class="py-10">
        <div class="px-4 sm:px-6 lg:px-8">
          <!-- Content -->
          <slot />
        </div>

        <Toaster />
      </main>

    </div>

  </div>
</template>

<style>
  .py-2 {
    padding-top: 0.1rem !important;
    padding-bottom: 0.1rem !important;
  }
  .\!py-2 {
    padding-top: 0.1rem !important;
    padding-bottom: 0.1rem !important;
  }
  .py-5 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .px-5 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .font-medium{
    font-weight: 400;
  }
  button.py-2{
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  aside .pl-11{
    padding-left: 1.7rem;
  }
  table .text-sm{
    font-size: 0.8rem !important;
  }
  aside li a span{
    font-size: 0.9rem;
  }
  @media (min-width: 1024px) {
    .lg\:pl-72 {
      padding-left: 16rem;
    }
  }
  h1.title{
    font-size: 1.5rem !important;
    text-transform: uppercase !important;
  }
  p.filter-title{
    font-weight: bold;
    text-transform: uppercase !important;
  }
  td .mr-4 {
    margin-right: 0.1rem;
  }
  div.mt-8{
    margin-top: 0.2rem;
  }
  div.state{
    width: 20px; 
    height: 20px;
    border-radius: 10px;
  }
</style>

<script lang="ts" setup >

const { $state, logout, setUnidade, makeNavigation } = useUsuarioStore();
const { obtemUnidadesAtivas } = useUnidadeMedica();
const rpconfig = useConfiguracao();
const configData = ref({});
const apiBase = useRuntimeConfig().public.apiBase;

import {
  Bars3Icon,
  BellIcon,
  CalendarIcon,
  ChartPieIcon,
  Cog6ToothIcon,
  DocumentDuplicateIcon,
  FolderIcon,
  HomeIcon,
  UsersIcon,
  XMarkIcon,
  BuildingOffice2Icon,
  FolderPlusIcon,
  BriefcaseIcon,
  WrenchScrewdriverIcon,
  UserCircleIcon,
} from "@heroicons/vue/24/outline";

import { ChevronDownIcon, MagnifyingGlassIcon, } from "@heroicons/vue/20/solid";

const sidebarOpen = ref(false);
const navigation = ref( [] );

const toasterStore = useToasterStore();

const message = ref("");
const userNavigation = [
  { name: "Meus Dados", link: "/usuarios/alterar-meus-dados", onClick: () => {} },
  { name: "Dados de Acesso", link: "/usuarios/alterar-dados-de-acesso", onClick: () => {} },
  { name: "Logout", link:"", onClick: () => useUsuarioStore().logout() },
];

let unidades = $state?.usuario?.unidades;

if(! unidades){
  unidades = [];
}
let unidade_logada = ref($state?.unidade?.id);

const trocaUnidadeLogada = (value: string) => {
  if(value!=0){
    let escolhida = unidades.filter( e => e.id==value )[0];

    setUnidade(escolhida);
    navigation.value = makeNavigation();
    unidade_logada.value = $state?.unidade?.id;
    location.href="/";
  }
  else{
    toasterStore.error({ text: "Escolha uma unidade válida" });
  }
};

rpconfig.obterUm(1)
  .then( ({ data: dat }) => {
    configData.value = dat.object;    
  });

onMounted(() => {
  message.value = "Olá "+($state?.usuario?.nome);
  navigation.value = makeNavigation();

  /*
  if($state.user && $state.user.type === 2){
    navigation.push(
      { name: "Empresas Pendentes", href: "/home/company/pendent", icon: BuildingOffice2Icon, current: false }
    );
  }

  if($state.isRegisterService){
    navigation.push(
      { name: "Meus Serviços", href: "/home/company/services", icon: BriefcaseIcon, current: false }
    );
  }
  */
});

</script>